import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { PatientAppointmentData } from '../../../@core/interfaces/patient-services/patient-appointment';
import { FormBuilder, FormGroup , FormControl, Validators } from '@angular/forms';
import { payerData } from '../../../@core/interfaces/patient-services/payer';
import { DatePipe, Location } from '@angular/common';
import * as gender from '../../../data/gender.json';
import { RolesData } from '../../../@core/interfaces/common/roles';
import { environment } from '../../../../environments/environment';
//import { Checkout } from 'capacitor-razorpay';
import { ApptBookingService } from '../../../_services/appt-booking.service';
import { access } from 'fs';
import { NbDateService, NbTabComponent, NbTabsetComponent } from '@nebular/theme';
import { OtpVerifyDialogComponent } from '../otp-verify-dialog/otp-verify-dialog.component';
import { DateService } from '../../../@theme/components/common/service/date.service';
import { NbAuthResult, NbAuthService } from '@nebular/auth';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { InitUserService } from '../../../@theme/services/init-user.service';
import { INgxSelectOption } from 'ngx-select-ex';
import * as title from './../../../data/title.json';
import { UserData } from '../../../@core/interfaces/common/users';
import { HttpClient } from '@angular/common/http';
declare var Razorpay: any;
import * as countryCodeLists from './../../../data/countryCode.json';


@Component({
  selector: 'ngx-booking-summary-login',
  templateUrl: './booking-summary-login.component.html',
  styleUrls: ['./booking-summary-login.component.scss']
})
export class BookingSummaryLoginComponent implements OnInit {
  titleList: any = (title as any).default;
  user: any;
  errors: any[];
  messages: any[];
  submitted: boolean;
  loginResult: any={};
  doctorId:string;
  docDetail:any;
  slotDate:any;
  slotTime:any;
  bookingPlatFormApp:FormGroup;
  clinicType:string;
  duration:any;
  isAppointmentSaved:boolean=false;
  placeholder:string='Select';
  genderList: string[]= (gender as any).default;
  loginForm:FormGroup;
  openLoginPopup:boolean=false;
  openForgotPopUpflag:boolean=false;
  mobileVerifyPopUp:boolean=false;
  loginData:any;
  resetPasswordForm:FormGroup;
  otpForm:FormGroup;
  isSubmitted:boolean=false;
  userAlreadyExists:boolean=false;
  patientLists:Array<any>=[];
  userList:Array<any>=[];
  loginUserAuthorized:boolean=false;
  protected readonly unsubscribe$ = new Subject<void>();
  invalidbookingPlatFormAppForm:boolean=false;
  registerPatientButtonMessage:string="Continue";
  updated: boolean=false;
  get apiUrl(): string {
    return environment.apiUrl;
  }
  loginPatient:any={};
  loginFlag:boolean=false;
  
  signUp:boolean=false;
  det: { DoctorId: string; Date: string; Duration: string; PatientName: string; PatientGender: string; PatientMobileNo: string; patientDOB: string; Type: string; regId: string; inputJson:string,CreatedBy:number,vaccineId:number,tenantId:string,branchId:string,departmentId:string};
  phoneNumber: number;
  OTPid:string;
  isSuccess: boolean = false;
  isFailure: boolean = false;
  lastFourDigits:string;
  maxDobDate: Date;
  vaccineFlag:boolean=false;
  vaccineDetail:any={};
  @ViewChild("digit1") d1Element: ElementRef;
  @ViewChild("digit2") d2Element: ElementRef;
  @ViewChild("digit3") d3Element: ElementRef;
  @ViewChild("digit4") d4Element: ElementRef;
  @ViewChild("digit5") d5Element: ElementRef;
  @ViewChild("digit6") d6Element: ElementRef;
  @ViewChild("verifybtn") verifyBtnElement: ElementRef;
  @ViewChild("tabSetRef") tabsetEl: NbTabsetComponent;
  @ViewChild("tabLogin") login: NbTabComponent;
  @ViewChild("registerTab") register: NbTabComponent;

  isPasswordMatch:boolean=false;
  showPassword:boolean = false;
  smscontent:string;
  sendthroughsms:boolean=false;
  isOtpDia: boolean =false;
  @ViewChild('otpVerify') otpVerifyInstance: OtpVerifyDialogComponent;
  passwordExists:boolean=false;
  
  fees:string;
  orderiddetails:Array<any>=[];
  username:string;
  mobilenum:string;
  orderid:string;
  payment='notpaid';
  templateData:Array<any>=[];
  regId:string;
  accessToken:string;
  patientDetails:Array<any>=[];
  password:string;
  rePassword:string;
  loginPassword:string;
  show:boolean = false;
  show2:boolean = false;
  show3:boolean = false;
  isNewPasswordEntered:boolean=false;
  isNewRePasswordEntered:boolean=false;
  isLoginPasswordEntered:boolean=false;

  fromPortalForEdit:string='fromPortalEdit';
  fromPortal:string='fromPortal';
  customer:boolean=true;
  tenatId = environment.patientTenantId;
  cusId = environment.patientCusID;
  branchId=environment.patientBranchId
  hospitalDetail:any={};
  countryCodeDropDownLists: Array<any>=[];
  mobileMinlength: number;
  mobileMaxlength: number;
  imageLinkList:Array<any>=[];
  @Input() docId:string;
  @Input() selectedDate:Date;
  @Input() selectedSlot:string;
  @Input() visitType:string;
  @Input() timeDuration:any;
  @Output() changeTime = new EventEmitter<void>();
  countryName:string;
  nearByCity:string;
  nearByRegion:string;
  countryCode:string;

  constructor(private datePipe: DatePipe, protected cd: ChangeDetectorRef,public router: Router,public DatService:DateService,protected dateService: NbDateService<Date>,private api: ApptBookingService,protected rolesService: RolesData,private route: ActivatedRoute,private getDrAppointmentService: PatientAppointmentData , private fb:FormBuilder , private phySrvc : payerData,private patSrvc: PatientRegistrationData, protected initUserService: InitUserService,protected service: NbAuthService,protected userService: UserData,private http:HttpClient,
    public location : Location,private patAptSrv: PatientAppointmentData) { 
    this.bookingPlatFormApp = this.fb.group({
      mobile: this.fb.control(null,[Validators.required,Validators.maxLength(20),Validators.minLength(10)]),
      firstName: this.fb.control(null,[Validators.required,Validators.pattern('^[\\u0020-\\u007E\\u00C0-\\u02AF\\u0370-\\u1FFF\\u2C00-\\uD7FF\\u0B80-\\u0BFF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\s]+$')]),
      lastName: this.fb.control(null,[Validators.pattern('^[\\u0020-\\u007E\\u00C0-\\u02AF\\u0370-\\u1FFF\\u2C00-\\uD7FF\\u0B80-\\u0BFF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\s]+$')]),
      dob: this.fb.control(null,[Validators.required]),
      gender:this.fb.control(null,[Validators.required]),
      title:this.fb.control(null,[Validators.required]),
       pass:this.fb.control(null,[Validators.required,Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{7,}$')]),
      confirmPass:this.fb.control(null,[Validators.required,Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{7,}$')]),
      mobileCountryCode: this.fb.control('',[Validators.required]) 
    });
    this.loginForm = this.fb.group({
      fullName: this.fb.control(null,[Validators.pattern('^[0-9]+$'), Validators.maxLength(20), Validators.minLength(10)]),
      password: this.fb.control(null),
      tenantId: this.fb.control(''),
      branchId: this.fb.control(''),
      rememberMe: this.fb.control(''),
    });
    this.resetPasswordForm=this.fb.group({
      resetMobile: this.fb.control(null,[Validators.required,Validators.pattern('^[0-9]+$'), Validators.maxLength(20), Validators.minLength(10)]),
      resetNewPassword: this.fb.control(null),
      reEnterNewPassword: this.fb.control(null)
    });
    this.otpForm = this.fb.group({
      digit1: this.fb.control('', [Validators.pattern('^[0-9-]+$'), Validators.maxLength(1), Validators.minLength(1)]),
      digit2: this.fb.control(''),
      digit3: this.fb.control(''),
      digit4: this.fb.control(''),
      digit5: this.fb.control(''),
      digit6: this.fb.control(''),
    });
    this.otpForm.get("digit1").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d2Element.nativeElement.focus());
    this.otpForm.get("digit2").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d3Element.nativeElement.focus());
    this.otpForm.get("digit3").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d4Element.nativeElement.focus());
    this.otpForm.get("digit4").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d5Element.nativeElement.focus());
    this.otpForm.get("digit5").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d6Element.nativeElement.focus());
    this.otpForm.get("digit6").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.verifyBtnElement.nativeElement.focus());
  }
  get fval() { return this.bookingPlatFormApp.controls; }
  get fval2() { return this.otpForm.controls; }
  get fval3() {return this.loginForm.controls;}
  get fval4() {return this.resetPasswordForm.controls;}

  ngOnInit(): void {
    this.maxDobDate = this.dateService.addDay(this.dateService.today(), 0);
    this.password = 'password';
    this.rePassword = 'password';
    this.hospitalDetail = JSON.parse(localStorage?.getItem('docDet'));
    // this.start();
    this.loadAllDoctorImages();
    this.loadCountryMaster();
    this.route.queryParams.subscribe(params => {
      this.countryCode = params['cc'];
    });

  }

  ngOnChanges(){
    this.doctorId = this.docId;
    this.slotDate = this.selectedDate;
    this.slotTime = this.selectedSlot;
    this.clinicType = this.visitType;
    this.duration = this.timeDuration;
  }

  onTabChange(event){
    if (event.tabTitle == 'Sign Up') {
      this.loadCountryMaster();
    }
  }

  loadAllDoctorImages(){
    this.rolesService.list("ImageAtchDet/" + environment.patientTenantId +'/null/all'+'?countryCode='+this.countryCode).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.imageLinkList = data;

    }, (error) => {
      this.loadDoctorDetail();
    }, () => {
      this.loadDoctorDetail();
    }); 
  }

  loadDoctorDetail(){
    let det={
      doctorId:this.doctorId,
      countryCode:this.countryCode
    }
    this.getDrAppointmentService.searchList(`bookingPlatform/getDrInfo`, det).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
      this.docDetail = data;
      const downloadData = this.imageLinkList.find(img => img.phyId === this.docDetail.doctorId)?.imageLink || '';
      if(downloadData) this.docDetail.imageLink = 'data:image/jpeg;base64,' + downloadData;
      else this.docDetail.imageLink = '';
    }, (error) => {
    }, () => {
    });
  } 


   loginCreate(): void {
    this.submitted=true;
    this.loginForm.controls["tenantId"].setValue(environment.virtualTenant.toLowerCase());
    this.loginForm.controls["branchId"].setValue(environment.virtualBranch.toLowerCase());  
    this.user = this.loginForm.value;  
    this.errors = [];
    this.messages = [];
    this.submitted = true;
    const auth ={
      "fullName": "9500672785",
      "password": "Ezovion@1",
      "rememberMe": "",
      "tenantId": "6b5d5bf1-e369-4b5d-e9b3-08dacd6f38e4",
      "branchId": "4e54f59e-226b-42a3-8ef2-cda3ac8fc727"
  }
    // this.patSrvc.post(`auth/loginForMobile`,auth).subscribe((data)=> {      

    //   const det = data
    // })
    this.service.authenticate("email", this.user).subscribe((result: NbAuthResult) =>
    {  
    // this.patSrvc.post(`auth/loginForMobile`,auth).subscribe((result)=> {
      this.submitted = false;
      this.loginResult =result;
      if (result.isSuccess()) {
        this.messages = result.getMessages();
        this.initUserService.initCurrentUser().subscribe();
        this.userAlreadyExists = false;
        var searchData={
          "searchWord": this.user.fullName,
          "fromDate": null,
          "toDate": null,
          "skip": 0,
          "take": 100
      };
        this.patSrvc.searchList("patientregistrationmst/" + environment.virtualTenant + '/' + environment.virtualBranch + '/search', searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {    
          this.loginPatient = data[0];
          var regID=data[0]?.id;
              var firstName=data[0]?.firstname;
              localStorage.setItem("loginuser","patientlogin");
              localStorage.setItem("regID",regID);
              localStorage.setItem("patientMobNo",this.user.fullName);
              localStorage.setItem("patientName",firstName);
              this.isSubmitted=false;
              localStorage.setItem("cc",this.countryCode);
              return this.router.navigate(['pages/patient-portal/confirm-booking',this.doctorId,this.slotDate,this.slotTime ,this.clinicType, this.duration]);
          });
      } else {
      
        // this.router.navigate(['auth/patient-portal']);
        if(result.getResponse().status == 403)
        this.errors.push("Your account has been disabled, Please see your administrator");
        else
        this.errors.push("Incorrect credentials. Try again.");
        this.router.navigate(['auth/patient-portal-booking-summary',this.doctorId,this.slotDate,this.slotTime ,this.clinicType, this.duration]);
      }


      this.cd.detectChanges();
    });
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    this.checkIsExists(event);
    return true;

  }

  checkIsExists(event){


if(event.target.value.length >= 10){
  let data={
    "PatientMobile":event.target.value
  }
  event.target.disabled = true;
  this.getDrAppointmentService.searchList(`bookingPlatform/checkIsPatientExists`, data).pipe(takeUntil(this.unsubscribe$)).subscribe(returnData => {
   
    this.patientLists = [];
    this.userList = [];
    
    // Check if the patient alone exists
    if (returnData.patient.length !== 0 && returnData.user == null) {
      this.patientDetails = returnData?.patient;
      this.bookingPlatFormApp.controls['firstName']?.setValue(this.patientDetails[0]?.firstname);
      this.bookingPlatFormApp.controls['lastName']?.setValue(this.patientDetails[0]?.lastname);
      this.bookingPlatFormApp.controls['dob']?.setValue(this.patientDetails[0]?.dob);
      this.bookingPlatFormApp.controls['gender']?.setValue(this.patientDetails[0]?.gender);
      this.bookingPlatFormApp.controls['mobile']?.setValue(this.patientDetails[0]?.mobile);

      this.userAlreadyExists = false;
    }
    // Check if both patient and user exist
    else if (!!returnData.patient && returnData.user != null) {
      this.userAlreadyExists = true;
      this.openLoginPopup = true;

      if (this.openLoginPopup) {
        this.tabsetEl.selectTab(this.login);
      }
      this.loginForm.get('fullName').setValue(event.target.value);
      this.patientLists = returnData.patient;
      this.userList = returnData.user;
    } 
    //when neither patient nor user exist
    else {
      this.userAlreadyExists = false;
      this.openLoginPopup = false;
      this.customer = false;
    }}, (error) => {
  }, () => {
    event.target.disabled = false;
  });
}

  }

  openForgotPopUp(){
    this.openForgotPopUpflag = true;
    var mbl = this.loginForm.get('fullName').value;
    if(mbl){
      this.resetPasswordForm.get('resetMobile').setValue(mbl);
    }
  }


  closeAppointmentSuccessPopup(){
    this.router.navigate(['/auth/patient-portal-appointment-booking']);
  }

  focustoOpenSelect($event){ 
    $event.optionsOpen()
  }
  tabToClose($event){
    $event.optionsClose()
  }

  onTitleChange(event: INgxSelectOption[]) {
    if (event[0].data.value == "1" || event[0].data.value == "5") {
      this.bookingPlatFormApp.controls['gender'].setValue("Male");
    }
    else if (event[0].data.value == "2" || event[0].data.value == "3" || event[0].data.value == "4") {
      this.bookingPlatFormApp.controls['gender'].setValue("Female");
    }
  }

       saveAppBookingReg(fromLogin?){
  
          if(this.bookingPlatFormApp.valid && this.bookingPlatFormApp?.get('pass')?.value === this.bookingPlatFormApp?.get('confirmPass')?.value || !!fromLogin){
            this.isSubmitted=true;
            let newData=new Date( this.bookingPlatFormApp.get('dob').value);
            const today = new Date();
        
            var Difference_In_Time = Math.abs(Date.now() - newData.getTime());
            var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
            var ageValue = Difference_In_Days / 365.25;
            const year = (Math.round(ageValue));
            const fullname=this.bookingPlatFormApp.get('firstName').value+(this.bookingPlatFormApp.get('lastName').value ?''+this.bookingPlatFormApp.get('lastName').value:'');
            let requestData ={
                branchId: environment.virtualBranch,
                email: null,
                fName:  this.bookingPlatFormApp.get('firstName').value,
                lName: null,
                mobileNum: this.bookingPlatFormApp.get('mobile').value,
                tenantId: environment.virtualTenantID,
                fullName: fullname,
                userFlag: "Patient",
                title: this.bookingPlatFormApp.get('title').value,
                gender: this.bookingPlatFormApp.get('gender').value,
                age: year,
                loginUserType: "patientlogin",
                password: this.bookingPlatFormApp.get('pass').value,
                confirmPassword: this.bookingPlatFormApp.get('confirmPass').value
              }
              this.http.post(environment.apiUrl+'/auth/sign-upForMobile',requestData).subscribe((res) => {
                this.isAppointmentSaved=true; 
                this.signUp=false;    
                setTimeout(()=>{ this.isAppointmentSaved=false;},4000);
                this.tabsetEl.selectTab(this.login);
                this.loginForm.get('fullName').setValue(this.bookingPlatFormApp.get('mobile').value)
            })
          }
          else{
            this.invalidbookingPlatFormAppForm=true;
          }
       
         
        }

   saveAppBooking(fromLogin?) {
    if (this.bookingPlatFormApp.valid || !!fromLogin) {
      this.isSubmitted = true;
      
      const vaccine={
        "vaccineId": this.vaccineDetail?.id,
        "planned_Date": "2025-06-28T00:00:00.000Z",
        "done_Date": null,
        "notes": null,
        "visitId": 0,
        "regId": this.loginPatient?.id,
        "isPastVaccine": false,
        "performingDoctor": null,
        "performingNurse": null,
        "patientportal": true,
        "name": this.vaccineDetail?.name,
        "tenantId":this.hospitalDetail?.tenandId,
        "branchId":this.hospitalDetail.branchId,
        "departmentId":this.hospitalDetail.departmentId
      }
      //e.Firstname + e.Middlename != "" ? " " + e.Middlename : "" +e.Lastname != "" ? " " + e.Lastname : ""
      var patdet = this.loginPatient;
     
      this.det = {
            DoctorId: this.doctorId,
            Date: this.slotDate,
            Duration: this.duration,
            PatientName:(patdet?.firstname+(patdet?.middlename ? ' ' + patdet?.middlename : '') + (patdet?.lastname ? ' ' + patdet?.lastname : '')),
            PatientGender: patdet?.gender ,
            PatientMobileNo: patdet?.mobile,
            patientDOB: patdet?.dob,
            Type: this.clinicType,
            regId: (this.vaccineFlag?null: patdet?.id),
            inputJson:this.vaccineFlag?JSON.stringify(vaccine):null,
            CreatedBy:parseInt(localStorage.getItem("userId")),
            vaccineId:this.vaccineFlag?this.vaccineDetail?.id:null,
            tenantId:this.hospitalDetail?.tenandId,
            branchId:this.hospitalDetail.branchId,
            departmentId:this.hospitalDetail.departmentId
          }

     const url = this.vaccineFlag?'bookPatientAppointmentVaccine':"bookPatientAppointment"
      this.phySrvc.create(`bookingPlatform/${url}`,this.det).pipe(takeUntil(this.unsubscribe$)).subscribe(appDet => {

        this.router.navigate(['/pages/patient-portal/appointment-list'], {
          queryParams: { payment: true }
        });

      }, (error) => {
        this.isAppointmentSaved = false;
        this.isSubmitted = false;
      }, () => {
        this.isAppointmentSaved = true;
        this.isSubmitted = false;
      });

    }
    else {
      this.invalidbookingPlatFormAppForm = true;
    }


  }

  verifyMobileIsexist()
  {
    if(!!this.resetPasswordForm.get('resetNewPassword').value && !!this.resetPasswordForm.get('reEnterNewPassword').value){
      this.passwordExists = false;
      if(this.resetPasswordForm.get('resetNewPassword').value === this.resetPasswordForm.get('reEnterNewPassword').value){
        this.isPasswordMatch = false;
        // this.errors = [];
        this.otpForm.reset({
          digit1: '',
          digit2: '',
          digit3: '',
          digit4: '',
          digit5: '',
          digit6: '',
        });
        this.mobileVerifyPopUp=true;
        this.phoneNumber = this.resetPasswordForm.get('resetMobile').value;
        this.lastFourDigits = this.phoneNumber.toString().slice(-4);
        if(!!this.phoneNumber && this.phoneNumber!=undefined){
          this.userService.getBranchList(`patient-portal/${this.tenatId}/${this.branchId}/${this.phoneNumber}/getCurrentUserData`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
            if(!!data){
              this.getotpsms();
            }
          })
       
        
        };
      }
      else{
        this.isPasswordMatch = true;
      }
    }
    else{
      this.passwordExists = true;
    }
    }

    getotpsms(){
      let data = {
        "headers": {
          "Accept": "application/vnd.ezovion.hateoas+json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
        }
      }
      this.rolesService.create(`${this.apiUrl}/patientportalnewuser/${this.tenatId}/sendotp/${this.phoneNumber}`,data).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.OTPid=data;
      // this.checksmspossibility();
      }, (error) => {
      }, () => {
      });
    }

    // To check sms send or not based on credit limit and template purchase based:-
    checksmspossibility(){
      let templateData;
      let istemplatepurchase;
      this.rolesService.list(`patientportalnewuser/${this.tenatId}/${this.branchId}/TemplateDet`).subscribe(data => {
        templateData=data;
        if(!!data){
          this.smscontent="Ezovion employees never ask for OTP. Sharing it with anyone allows unauthorized access to your Ezovion account. Your OTP is " + this.OTPid + ". It will be valid for 2 minutes only. Thanks, Ezovion.";
            istemplatepurchase = templateData.sms.purchasedTemplateDet.filter(x =>x.commonTemplateMstDet?.smsTemplateNameMst?.templateName.toLocaleLowerCase() == "ezovion-otp")
            if(istemplatepurchase?.length>0){
              if(istemplatepurchase.length-1>-1){ 
                if(istemplatepurchase[istemplatepurchase.length-1]?.creditBalance > 0){
                  this.sendthroughsms=true; 
                  this.templateData=istemplatepurchase[istemplatepurchase.length-1];
                  this.sendSMS(istemplatepurchase[istemplatepurchase.length-1]);
                }
              }
              else{
                this.sendthroughsms=false; 
              }
            }
            else{
              this.sendthroughsms=false; 
            }
            // this.isOtpDia = true;
            // this.cd.detectChanges();
            // this.otpVerifyInstance.fromforgotPassword("forgotPassword")
        }
      }, (error) => {
      }, () => {
      });
    }

    // To send sms for registration save and update:-
  sendSMS(templateData){
    let smstrackingDetails={
      referencefrom:"ezovion-otp",
      referencenum:'0',
      mobileNumber:this.phoneNumber,
      dateTime:this.DatService.currentDate(),
      message:this.smscontent,
      smsUnit:1,
      senderId:templateData.smsgatewaysettingsDet.serviceName,
      status:"ok",
      templateId:templateData.commonTemplateMstDet.templateDetId,
      createdIp:null,
      createdby:parseInt(localStorage.getItem("userId")),
      createddate:this.DatService.currentDate(),
      tenantId:this.tenatId,
      branchId:this.branchId
    }
    
    let smsContent={
      text:this.smscontent,
      mobile:this.phoneNumber,
      apiURL:templateData.smsgatewaysettingsDet.providerUrl,
      apiKey:templateData.smsgatewaysettingsDet.providerKey,
      route:templateData.smsgatewaysettingsDet.serviceType,
      senderId:templateData.smsgatewaysettingsDet.serviceName,
      tenantId:this.tenatId,
      branchId:this.branchId,
      smstrackingDetails:smstrackingDetails,
      tenantApiConfigId:templateData?.tenantApiConfigId,
    }
    this.rolesService.create(`${this.apiUrl}/patientportalnewuser/${this.tenatId}/sendSMS`, smsContent).subscribe(data => {
    }, (error) => {
    }, () => {
    });
  }

  enterPassword(){
    if(!!this.resetPasswordForm.get('resetNewPassword').value){
      this.isNewPasswordEntered = true;
    }
    else{
      this.isNewPasswordEntered = false;
      this.password = 'password';
      this.show = false;
    }
  }

  enterRePassword(){
    if(!!this.resetPasswordForm.get('reEnterNewPassword').value){
      this.isNewRePasswordEntered = true;
    }
    else{
      this.isNewRePasswordEntered = false;
      this.rePassword = 'password';
      this.show2 = false;
    }
  }

  enterLoginPassword(){
    if(!!this.loginForm.get('password').value){
      this.isLoginPasswordEntered = true;
    }
    else{
      this.isLoginPasswordEntered = false;
      this.loginPassword = 'password';
      this.show3 = false;
    }
  }

  togglePassword(){
    if (this.password === 'password') {
      this.password = 'text';
      this.show = true;
    } else {
      this.password = 'password';
      this.show = false;
    }
  }

  togglerePassword(){
    if (this.rePassword === 'password') {
      this.rePassword = 'text';
      this.show2 = true;
    } else {
      this.rePassword = 'password';
      this.show2 = false;
    }
  }

  toggleLoginPassword(){
    if (this.loginPassword === 'password') {
      this.loginPassword = 'text';
      this.show3 = true;
    } else {
      this.loginPassword = 'password';
      this.show3 = false;
    }
  }

    onVerify() {

      let otp = "";
      otp += this.otpForm.get('digit1').value;
      otp += this.otpForm.get('digit2').value;
      otp += this.otpForm.get('digit3').value;
      otp += this.otpForm.get('digit4').value;
      otp += this.otpForm.get('digit5').value;
      otp += this.otpForm.get('digit6').value;
      if (otp != "") {
        if (otp == this.OTPid) {
          this.isSuccess = true;
          this.isFailure = false;
          this.mobileVerifyPopUp = false;
          this.openForgotPopUpflag = false;
          setTimeout(()=>{this.isSuccess = false;},3000)
          const det = {
            Password: this.resetPasswordForm.get('resetNewPassword').value,
            ConfirmPassword: this.resetPasswordForm.get('reEnterNewPassword').value,
            MobileNumber: this.phoneNumber
          }
          this.patSrvc.searchList('auth/updatePassword',det).pipe(takeUntil(this.unsubscribe$)).subscribe(()=>{
            this.resetPasswordForm.reset();
            this.updated = true;
            setTimeout(()=>{this.updated = false;},4000)
          })
          // this.diaClose.emit({ otpStatus: "approved" });
          // if (this.fromPage != "PatientPortal" && this.fromPage != "forgotPassword")
          //   this.sendsms();
        }
        else {
          this.isFailure = true;
          this.isSuccess = false;
        }
  
      }
    }

    otpFormClose(){
      this.mobileVerifyPopUp=false; 
      this.otpForm.reset({
        digit1: '',
        digit2: '',
        digit3: '',
        digit4: '',
        digit5: '',
        digit6: '',
      });
    }

   
  getorderid() {
    let data = {
        "amount": this.fees+'00',
        "currency": "INR",
        "receipt": "rcptid_11"
    }
    this.api.getorderidpayment(data, this.accessToken).subscribe(async (data: any) => {
      this.orderiddetails = data.attributes;
      const order_id = data.attributes.id;
      const currency = data.attributes.currency;
      const amount = data.attributes.amount;
      this.payWithRazor(order_id, currency, amount);
    }, async (err) => {
      this.saveAppBooking('fromLogin');
    })
  }

   payWithRazor(order_id, currency, amount) {
    var options = {
      key: 'rzp_test_RFmryJmgIzI0ps',
      amount: amount,
      description: 'Book Appointment',
      image: 'https://i.imgur.com/3g7nmJC.jpg',
      order_id: order_id,
      currency: currency,
      name: this.loginPatient?.firstname,
      handler: this.saveAppBooking.bind(this), 
      //function (response: any) {
      //   
      //   this.payment = 'paid';
      //   this.isAppointmentSaved = true;
      //   this.openLoginPopup = false;
       
      //   // let det = {
      //   //   DoctorId: 'this.doctorId',
      //   //   Date: 'this.slotDate',
      //   //   Duration: 'this.duration',
      //   //   PatientName: "this.patientDetails[0].firstname + (this.patientDetails[0].lastname ? ' ' + this.patientDetails[0].lastname : '')",
      //   //   PatientGender: "this.patientDetails[0].gender ? this.patientDetails[0].gender : ''",
      //   //   // PatientMobileNo: this.patientDetails[0].mobile,
      //   //   // patientDOB: this.patientDetails[0].dob,
      //   //   // Type: this.clinicType,
      //   //   // regId: this.patientDetails[0].id
      //   // }
      //   // this.phySrvc?.create(`bookingPlatform/bookPatientAppointment`, det)?.pipe(takeUntil(this?.unsubscribe$))?.subscribe(appDet => {
      //   //   
      //   //   this.appointmentDetails = appDet;
      //   //  })

      //   // alert(response.razorpay_payment_id);
      //   // alert(response.razorpay_order_id);
      //   // alert(response.razorpay_signature);

      //   // // after success response  call api verifypaymentsignature
      //   // 
      //   // let signaturedata = {
      //   //   "razorpay_order_id": response.razorpay_order_id,
      //   //   "razorpay_payment_id": response.razorpay_payment_id,
      //   //   "razorpay_signature": response.razorpay_signature
      //   // }
      //   // this.api.verifypaymentsignature(signaturedata, this.accessToken).subscribe(async (data1: any) => {
      //   //   console.log(data1);

      //   // }, async (err) => {
      //   //   if (err.error.text === "Success") {
      //   //     this.payment = 'paid';
      //   //     this.isAppointmentSaved = true;
      //   //     this.openLoginPopup = false;
      //   //     this.saveAppBooking();
      //   //   }
      //   //   else {
      //   //     this.isAppointmentSaved = false;
      //   //   }
      //   // })
      // },
      // callback_url: "https://eneqd3r9zrjok.x.pipedream.net/",
      modal: {
        escape: false,
      },
      prefill: {
        email: '',
        contact:  this.loginPatient?.mobile,
      },
      "theme": {
        "color": "#3399cc"
      }
    };
    
    var rzp1 = new Razorpay(options);
    rzp1.on('payment.failed', function (response) {
      // alert(response.error.code);
      // alert(response.error.description);
      // alert(response.error.source);
      // alert(response.error.step);
      // alert(response.error.reason);
      // alert(response.error.metadata.order_id);
      // alert(response.error.metadata.payment_id);
      this.payment = 'Notpaid';
      this.isAppointmentSaved = false;
      
    });
    document.getElementById('rzp-button1').onclick = function (e) {
      rzp1.open();
      e.preventDefault();
    }
  }

  onCountryCodeChange(code , type) {
  if(type=='Mobile'){
      this.mobileMinlength = code[0]?.data?.minMobileNumberLength ;
      this.mobileMaxlength = code[0]?.data?.maxMobileNumberLength ;
      this.bookingPlatFormApp.get('mobile').setValidators([Validators.minLength(this.mobileMinlength) , Validators.maxLength(this.mobileMaxlength)]);
      this.bookingPlatFormApp.get('mobile').updateValueAndValidity(); 
  }}
  
    async paynow() {
       //'rzp_live_br37R848nUFkMb'
      const options = {
        key: 'rzp_live_br37R848nUFkMb',
        amount:this.orderiddetails[0].amount,
        description: 'Book Appointment',
        image: 'https://i.imgur.com/3g7nmJC.jpg',
        order_id: this.orderiddetails[0].id,//Order ID generated in Step 1
        currency: this.orderiddetails[0].currency,
        name: this.username,
        prefill: {
          email: '',
          contact: this.mobilenum
        },
        theme: {
          color: '#852677;'
        }
      }
      try {
        let data = null;
        let sample =JSON.stringify(data);
        let nextsample = JSON.parse(sample)
        this.orderid =nextsample.response.razorpay_order_id;
        let signaturedata={
          "razorpay_order_id": nextsample.response.razorpay_order_id,
          "razorpay_payment_id": nextsample.response.razorpay_payment_id,
          "razorpay_signature": nextsample.response.razorpay_signature
      }
        this.api.verifypaymentsignature(signaturedata,this.accessToken).subscribe(async (data1:any) => {
          // console.log(data1);
          
        }, async (err) => {
          if(err.error.text === "Success"){
            this.payment ='paid';
            this.isAppointmentSaved = true;
            this.openLoginPopup = false;
          }
          else{
            this.isAppointmentSaved = false;
          }
        })
    
      } catch (error) {
        //it's paramount that you parse the data into a JSONObject
        let errorObj = JSON.parse(error['code'])
      }
  
    }

    onChangeDateTime() {
    this.changeTime.emit();
  }

  onClickSignUp(){
    this.tabsetEl.selectTab(this.register);
  }
  


    loadCountryMaster(): void {
        this.patAptSrv.list(`countries/getCountryMasterAnonymous`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          this.countryCodeDropDownLists = data.details;
          
        }, (error) => {
          if(error.status==401){
            this.router.navigateByUrl('/auth/patient-portal');
          }
        }, () => {
          // this.signUp = true;
          this.bookingPlatFormApp.reset();
          this.invalidbookingPlatFormAppForm = false;
          this.route.queryParams.subscribe(params => {
          if(!!params.cc){
            const countryCode = this.countryCodeDropDownLists.filter(x => x.countryCode == params.cc);
            if(countryCode.length>0){
              this.bookingPlatFormApp.get('mobileCountryCode')?.setValue(countryCode[0]?.id);
            }
          }
        });
        });
      }

}
